export const DEFAULT_MIME_TYPES = [
    'image/*',
    'text/*',
    'application/*',
    'audio/*',
    'video/*',
    'application/pdf',
    'application/zip',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    'application/vnd.ms-word.document.macroEnabled.12',
    'application/vnd.ms-word.template.macroEnabled.12',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.ms-excel.template.macroEnabled.12',
    'application/vnd.ms-excel.addin.macroEnabled.12',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.template',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    'application/vnd.ms-powerpoint.addin.macroEnabled.12',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.ms-powerpoint.template.macroEnabled.12',
    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
    'application/vnd.ms-access',
];

export enum FileStackSource {
    LOCAL_FILE_SYSTEM = 'local_file_system',
    DROPBOX = 'dropbox',
    GOOGLE_DRIVE = 'googledrive',
    GMAIL = 'gmail',
}

export const FILE_STACK_DEFAULT_SOURCES = [
    FileStackSource.LOCAL_FILE_SYSTEM,
    FileStackSource.DROPBOX,
    FileStackSource.GOOGLE_DRIVE,
    FileStackSource.GMAIL,
];

export const DEFAULT_MAX_SIZE = 1024 * 1024 * 10; // 10MB

export const DEFAULT_UPLOAD_IN_BACKGROUND = true;
